export const FETCH_PAYMENTS_REQUEST = 'FETCH_PAYMENTS_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_FAILED = 'FETCH_PAYMENTS_FAILED';

export const FETCH_PAYMENT_METHODS_REQUEST = 'FETCH_PAYMENT_METHODS_REQUEST';
export const FETCH_PAYMENT_METHODS_SUCCESS = 'FETCH_PAYMENT_METHODS_SUCCESS';
export const FETCH_PAYMENT_METHODS_FAILED = 'FETCH_PAYMENT_METHODS_FAILED';

export const FETCH_PAYMENT_BY_ID_REQUEST = 'FETCH_PAYMENT_BY_ID_REQUEST';
export const FETCH_PAYMENT_BY_ID_SUCCESS = 'FETCH_PAYMENT_BY_ID_SUCCESS';
export const FETCH_PAYMENT_BY_ID_FAILED = 'FETCH_PAYMENT_BY_ID_FAILED';

export const FETCH_ADD_PAYMENT_METHOD_REQUEST = 'FETCH_ADD_PAYMENT_METHOD_REQUEST';
export const FETCH_ADD_PAYMENT_METHOD_SUCCESS = 'FETCH_ADD_PAYMENT_METHOD_SUCCESS';
export const FETCH_ADD_PAYMENT_METHOD_FAILED = 'FETCH_ADD_PAYMENT_METHOD_FAILED';

export const FETCH_DELETE_PAYMENT_METHOD_REQUEST = 'FETCH_DELETE_PAYMENT_METHOD_REQUEST';
export const FETCH_DELETE_PAYMENT_METHOD_SUCCESS = 'FETCH_DELETE_PAYMENT_METHOD_SUCCESS';
export const FETCH_DELETE_PAYMENT_METHOD_FAILED = 'FETCH_DELETE_PAYMENT_METHOD_FAILED';

export const FETCH_UPDATE_PAYMENT_METHOD_REQUEST = 'FETCH_UPDATE_PAYMENT_METHOD_REQUEST';
export const FETCH_UPDATE_PAYMENT_METHOD_SUCCESS = 'FETCH_UPDATE_PAYMENT_METHOD_SUCCESS';
export const FETCH_UPDATE_PAYMENT_METHOD_FAILED = 'payment/FETCH_UPDATE_PAYMENT_METHOD_FAILED';

export const FETCH_CHECKOUT_SESSION_REQUEST = 'payment/FETCH_CHECKOUT_SESSION_REQUEST';
export const FETCH_CHECKOUT_SESSION_SUCCESS = 'payment/FETCH_CHECKOUT_SESSION_SUCCESS';
export const FETCH_CHECKOUT_SESSION_FAILED = 'payment/FETCH_CHECKOUT_SESSION_FAILED';

export const RESET_FETCH_PAYMENT_METHODS = 'payment/RESET_FETCH_PAYMENT_METHODS';
